export default __webpack_public_path__ + "static/media/home_edit_icon.9774a892.svg";